import { render, staticRenderFns } from "./FormIcono.vue?vue&type=template&id=61e269ef&scoped=true"
import script from "./FormIcono.vue?vue&type=script&lang=js"
export * from "./FormIcono.vue?vue&type=script&lang=js"
import style0 from "./FormIcono.vue?vue&type=style&index=0&id=61e269ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e269ef",
  null
  
)

export default component.exports